@if (convertedHistoryPeriods.length) {
  <div class="history-periods">
    <div class="history-periods__title">
      {{ "date-range-selection.label.recent-periods" | translate }}
    </div>
    <div class="history-periods__list history-timeline">
      @for (
        period of visibleHistoryPeriods;
        track trackByPeriod($index, period)
      ) {
        <button
          type="button"
          class="history-period"
          (click)="selectPeriod(period)"
        >
          <span class="history-period__marker" aria-hidden="true">
            <span class="history-period__dot"></span>
          </span>
          <span class="history-period__range">
            <span class="history-period__date">{{ period.startLabel }}</span>
            <fa-icon
              class="history-period__arrow"
              [icon]="['fas', 'arrow-right']"
            ></fa-icon>
            <span class="history-period__date">{{ period.endLabel }}</span>
          </span>
          <fa-icon
            class="history-period__remove"
            [icon]="['fas', 'xmark']"
            [suiTooltip]="
              'date-range-selection.tooltip.remove-period' | translate
            "
            (click)="removePeriod($event, period)"
          ></fa-icon>
        </button>
      }
    </div>
    @if (hiddenHistoryCount > 0 || historyExpanded) {
      <button
        type="button"
        class="history-periods__toggle"
        (click)="toggleHistoryExpanded()"
      >
        @if (historyExpanded) {
          <span>
            {{ "date-range-selection.button.show-less" | translate }}
          </span>
        } @else {
          <span>
            {{
              "date-range-selection.button.show-more"
                | translate: { count: hiddenHistoryCount }
            }}
          </span>
        }
        <fa-icon
          [icon]="['fas', historyExpanded ? 'chevron-up' : 'chevron-down']"
        ></fa-icon>
      </button>
    }
  </div>
}
